import { UseFormSetValue } from "react-hook-form";
import { Usina } from "../../modules/usinas/types";
import {
  TableContainer,
  Table,
  TableRow,
  TableCell,
  TableBody,
  Checkbox,
} from "@mui/material";
import { CSSProperties, useEffect, useState } from "react";
import { usinasApi } from "../../services/api";

export default function SelectUsinasTable(props: {
  setValue: UseFormSetValue<any>;
  selectedUsinasIds: string[];
  fieldName?: string;
  avaliableUsinasIds?: string[];
  style?: CSSProperties;
}) {
  const { setValue, selectedUsinasIds, fieldName, avaliableUsinasIds, style } =
    props;
  const [usinas, setUsinas] = useState<Usina[]>([]);

  useEffect(() => {
    onMount();
  }, []);
  const onMount = async () => {
    const response = await usinasApi.getUsinas();
    const data = response.data;
    const usinas = avaliableUsinasIds
      ? data.filter((u) => avaliableUsinasIds.includes(u.usinaIds.id))
      : data;
    setUsinas(usinas);
  };
  const usinasIds = usinas.map((u) => u.usinaIds.id);
  const isAllUsinasSelecteds = usinasIds.every((u) =>
    selectedUsinasIds.includes(u)
  );
  return (
    <TableContainer
      style={
        style ?? {
          maxHeight: "300px",
          // width: "100%",
          overflow: "auto",
        }
      }
    >
      <Table size="small" stickyHeader>
        <TableBody>
          {usinas.length > 1 && (
            <TableRow hover>
              <TableCell align="left">
                <Checkbox
                  onChange={(_, checked) => {
                    if (checked) {
                      setValue(fieldName ?? "usinasIds", usinasIds);
                    } else {
                      setValue(fieldName ?? "usinasIds", []);
                    }
                  }}
                  checked={isAllUsinasSelecteds}
                  inputProps={{ "aria-label": "controlled" }}
                />
                Todas
              </TableCell>
            </TableRow>
          )}

          {usinas.map((usina) => {
            const isChecked = selectedUsinasIds.find(
              (u) => u == usina.usinaIds.id
            )
              ? true
              : false;
            return (
              <TableRow hover key={usina.usinaIds.id}>
                <TableCell align="left">
                  <Checkbox
                    onChange={(_, checked) => {
                      let updatedSelectedUsinasIds = [...selectedUsinasIds];
                      if (checked) {
                        updatedSelectedUsinasIds.push(usina.usinaIds.id);
                      } else {
                        updatedSelectedUsinasIds = selectedUsinasIds.filter(
                          (u) => u !== usina.usinaIds.id
                        );
                      }
                      setValue(
                        fieldName ?? "usinasIds",
                        updatedSelectedUsinasIds
                      );
                    }}
                    checked={isChecked}
                    inputProps={{ "aria-label": "controlled" }}
                  />
                  {usina.name}
                </TableCell>
              </TableRow>
            );
          })}
        </TableBody>
      </Table>
    </TableContainer>
  );
}
